import { render, staticRenderFns } from "./TaskPriorityIcon.vue?vue&type=template&id=ff26fd98&scoped=true"
import script from "./TaskPriorityIcon.vue?vue&type=script&lang=ts"
export * from "./TaskPriorityIcon.vue?vue&type=script&lang=ts"
import style0 from "./TaskPriorityIcon.vue?vue&type=style&index=0&id=ff26fd98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff26fd98",
  null
  
)

export default component.exports